import React from "react";
import "./Sort_By_Modal.css";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import Pink_Btn from "../../common_btn/pink_btn/Pink_Btn";

const Sort_By_Modal = ({ sortBy, setSortBy, ...props }) => {
  const {
    control,
    reset,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const countries = [
    { value: "chocolate", label: "Chocolate" },
    { value: "strawberry", label: "Strawberry" },
    { value: "vanilla", label: "Vanilla" },
  ];


  const setFilter = async (params) => {
    setSortBy(params?.sortBy || "default");
    props?.onHide();

  }



  return (
    <>
      <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="common_modal Sort_By_Modal"
      >
        <Modal.Body>
          <div
            className="close_img_div_new"
            onClick={() => {
              props?.onHide();
            }}
          >
            <img src="/assets/images/icons/close.png" className="close_img" />
          </div>

          <div className="searchpost_div">
            <div>
              <div className="modal_header">
                <p className="left_text">Sort by</p>
              </div>

              <Form>
                <div className="radio-group">
                  <Form.Check
                    type="radio"
                    label="Default"
                    value="default"
                    {...register("sortBy", {
                      required: "Please select a sort option",
                    })}
                  />
                  <Form.Check
                    type="radio"
                    label="Price - High to Low"
                    // value="PriceHighLow"
                    value="price_desc"
                    {...register("sortBy")}
                  />
                  <Form.Check
                    type="radio"
                    label="Price - Low to High"
                    // value="PriceLowHigh"
                    value="price_asc"
                    {...register("sortBy")}
                  />
                  <Form.Check
                    type="radio"
                    label="Discount - High to Low"
                    // value="DiscountHighLow"
                    value="discount_desc"
                    {...register("sortBy")}
                  />
                </div>

                <div className="btn_holder">
                  <Pink_Btn btnText={"Search"}
                    onClick={handleSubmit(setFilter)}

                  />
                </div>
              </Form>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Sort_By_Modal;
